import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import styles from '../../../styles/icons/base.module.scss';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    color: 'currentColor',
    className: null,
};

function FlameIcon({ color,className }) {
    return (
        <svg
            className={classNames([styles.container, {[className]: className !== null }])}
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width={19.32}
            height={22.2}
            viewBox="0 0 19.32 22.2"
        >
            <path
                fill={color}
                d="M5.58,21.88c-1.44-3-0.67-4.71,0.43-6.33c0.73-1.07,1.25-2.26,1.52-3.52
	c0.61,0.94,0.82,2.08,0.57,3.17c1.37-1.68,2-3.85,1.75-6c3.95,2.92,5.3,8.22,3.24,12.68c11.65-6.59,2.9-16.46,1.37-17.57
	c0.51,1.11,0.6,2.99-0.42,3.9c-1.74-6.59-6.03-7.94-6.03-7.94c0.51,3.4-1.84,7.11-4.11,9.89c0.02-1.25-0.28-2.48-0.87-3.58
	c-0.16,2.46-2.04,4.47-2.55,6.93C-0.21,16.85,1,19.3,5.58,21.88z"
            />
        </svg>
    );
}

FlameIcon.propTypes = propTypes;
FlameIcon.defaultProps = defaultProps;

export default FlameIcon;
